/* unplugin-vue-components disabled */import script from "./GeneralCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneralCompany.vue?vue&type=script&setup=true&lang=js"

import "./GeneralCompany.vue?vue&type=style&index=0&id=1d7cd4d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d7cd4d4"]])

export default __exports__